﻿$.fn.dxCtrlGrid = function custom_dxCtrlGrid(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgrid dx-ctrl");
        this.createInstance(new cdxCtrlGrid(this, option));
    }
    return this;
}

window.cdxCtrlGrid = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.allowCarto == 'undefined') option.allowCarto = false
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible = false
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == 'undefined') {
        if (typeof option.typeGrille == 'undefined') { option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = option.lstTypeGrille[0] }
        else { option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = option.typeGrille }
    }

    var ctrlResize = null;
    var dxGrid = null
    var dxCarto = null

    this.jauge = null
    var firstLoad = true
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        //if (option.allowCarto) {
        //    if (!option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible) {
        //        option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = true
        //    } else {
        //        //construit carto
        //        option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = false
        //    }
        //    Me.jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //    ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
        //        bddCtrl: option.bddCtrl,
        //        context_grid: option.context_grid,
        //        withMarge: false,
        //        minSizeRight: 100,
        //        widthLeftInitial: container.innerWidth() / 2
        //    }).dxCtrlSplitterResize2("instance")
        //    ctrlResize.mConstruitLeft(function (contentElement) {
        //        mRempliGrid(contentElement)
        //        //if (option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible) mConstruitCarto()
        //        if (option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible) {
        //            option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible = false
        //            window.setTimeout(function () {
        //                Me.mShowHideCarto()
        //                option.dxVirtualGrid.mReloadData(true)
        //                //dxGrid.mReloadData(dxCarto.mGetLstDataGridVisible())
        //            }, 500)
        //        }
        //    })
        //    //resizeObserver.mAdd(container, function () {
        //    //    ctrlResize.component().beginUpdate()
        //    //    ctrlResize.component().endUpdate()
        //    //})
        //} else {
        //}
        mRempliGrid(container)
        Me.jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        function mRempliGrid(contentElement) {
            contentElement.empty()
            switch (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille) {
                case "Lignes": case "Détails": case "Details": case "Modif":
                    dxGrid = $("<div/>").appendTo(contentElement).dxCtrlGridAnim({
                        typeGrille: option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille,
                        typeData: option.typeData,
                        isForDoublon: option.isForDoublon,
                        dataGridVue: option.dataGridVue,
                        readOnly: (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille != "Modif"),
                        paddingLeftRightRow: option.paddingLeftRightRow,
                        fields: option.fields,
                        hideEntete: option.hideEntete,
                        hideItemPlus: option.hideItemPlus,
                        hideRound: option.hideRound,
                        allow_columnchooser: option.allow_columnchooser,
                        onHoverDataGrid: option.onHoverDataGrid,
                        nomTemplateDisplay: option.nomTemplateDisplay,
                        nomTemplateIco: option.nomTemplateIco,
                        nomTemplatePlus: option.nomTemplatePlus,
                        getItemTemplateHeight: option.getItemTemplateHeight,
                        bddCtrl: option.bddCtrl,
                        context_grid: option.context_grid,
                        allowCheck: option.allowCheck,
                        allowGroup: option.allowGroup,
                        noPagination: option.noPagination,
                        optionTemplate: option.optionTemplate,
                        allowModifTemplateStrCon: option.allowModifTemplateStrCon,
                        onDisplayButtonLigne: option.onDisplayButtonLigne,
                        noDataText: function (contentElement) { noDataText(contentElement) },
                        getAlignItem: option.getAlignItem,
                        showColumnHeaders: option.showColumnHeaders,
                        itemTemplateGrille: option.itemTemplateGrille,
                        itemTemplateGrillePlus: option.itemTemplateGrillePlus,
                        itemTemplateIco: option.itemTemplateIco,
                        onClickDataGrid: option.onClickDataGrid,
                        onEndClickDataGrid: option.onEndClickDataGrid,
                        onDemandeReloadData: option.onDemandeReloadData,
                        onDemandeData: option.onDemandeData,
                        onSelectionChanged: option.onSelectionChanged,
                        onToolbarPreparing: option.onToolbarPreparing,
                        onFirstContentReady: option.onFirstContentReady,
                        onDemandeReconstruit: option.onDemandeReconstruit,
                        grilleBackgroundColor: option.grilleBackgroundColor,
                        showPager: option.showPager
                    }).dxCtrlGridAnim("instance")

                    break;
                case "Excel":
                    dxGrid = $("<div style='height:100%'/>").appendTo(contentElement).dxCtrlGridExcel({
                        bddCtrl: option.bddCtrl,
                        context_grid: option.context_grid,
                        typeData: option.typeData,
                        allowCheck: option.allowCheck,
                        allowGroup: option.allowGroup,
                        fields: option.fields,
                        noDataText: option.noDataText,
                        showColumnHeaders: option.showColumnHeaders,
                        onClickDataGrid: option.onClickDataGrid,
                        onEndClickDataGrid: option.onEndClickDataGrid,
                        onDemandeReloadData: option.onDemandeReloadData,
                        onDemandeData: option.onDemandeData,
                        onSelectionChanged: option.onSelectionChanged,
                        onToolbarPreparing: option.onToolbarPreparing,
                        onFirstContentReady: option.onFirstContentReady
                    }).dxCtrlGridExcel("instance")
                    break;
                case "carto":
                    if (firstLoad) {
                        window.setTimeout(function () { mRempliCarto() }, 0)
                    } else {
                        mRempliCarto()
                    }
                    function mRempliCarto() {
                        dxGrid = $("<div style='width:100%;height:100%'/>").appendTo(contentElement).dxCtrlCarto({
                            bddCtrl: option.bddCtrl,
                            context_grid: option.context_grid,
                            //onDisplayChanged: function (e) {
                            //    if (!dxCarto) return
                            //    dxGrid.mReloadData(dxCarto.mGetLstDataGridVisible())
                            //},
                            onSelectionChanged: option.onSelectionChanged,
                            onContentReady: function (e) {
                                if (typeof (option.onToolbarPreparing != 'undefined')) {
                                    option.onToolbarPreparing({ toolbarOptions: e.component.mGetToolbar().option() })
                                }
                                window.setTimeout(function () { e.component.mGetToolbar().repaint() }, 0)
                            }
                        }).dxCtrlCarto("instance")
                    }
                    break;
            }
            firstLoad = false
        }
    }

    function noDataText(contentElement) {
        contentElement.css("white-space", "normal")
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] != 'undefined' &&
            typeof option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible != 'undefined' &&
            option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible) {
            contentElement.html("Aucun élément géolocalisé dans cette portion de territoire.<br/>(Naviguer dans la carte pour les faire apparaitre.)")
            $("<br/>").appendTo(contentElement)
            var $A = $("<a href='javascript:void(0)'>Désactiver la carte pour afficher tous vos contacts</a>").appendTo(contentElement)
            $A.on("click", function (e) {
                Me.mShowHideCarto()
                option.onDemandeReloadData()
            })
        } else {
            if ($.isFunction(option.noDataText)) { option.noDataText(contentElement) }
            else { contentElement.html(option.noDataText) }
        }
    }

    this.mGetModeSelection = function () { return dxGrid.mGetModeSelection() }
    this.mSwitchCheck = function () { dxGrid.mSwitchCheck() }

    this.mReinitState = function () { dxGrid.mReinitState(); }
    this.mRepaintRow = function (dataGrid, rechargeTemplate) { dxGrid.mRepaintRow(dataGrid, rechargeTemplate) }
    this.mRemoveRows = function (lstDataGrid) { dxGrid.mRemoveRows(lstDataGrid) }
    this.mRemoveRow = function (dataGrid) { dxGrid.mRemoveRow(dataGrid) }
    this.mUpdateSearchLucene = function (txtSearch, dxCtrlRecherche) {
        if (typeof dxGrid.mUpdateSearchLucene != 'undefined') dxGrid.mUpdateSearchLucene(txtSearch, dxCtrlRecherche)
    }
    this.mGetLstData = function () { return dxGrid.mGetLstData() }
    this.mGetLstSelectedData = function () { return dxGrid.mGetLstSelectedData() }
    this.mChangeSelectAll = function (selectAll) { dxGrid.mChangeSelectAll(selectAll) }
    this.mUpdateData = function (action, idTable, id) { dxGrid.mUpdateData(action, idTable, id) }
    this.mReloadData = function (lstData, animate) {
        if (dxCarto) {
            dxCarto.mReloadData(lstData)
            dxCarto.mGetLstDataGridVisible()
        } else {
            dxGrid.mReloadData(lstData, animate)
        }
    }

    this.mGetToolbar = function () {
        if (dxGrid) return dxGrid.mGetToolbar()
    }

    this.mShowHideCarto = function () {
        option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible = !option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible
        option.bddCtrl.mSaveParaJsonUtilisateur();
        if (option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible) {
            ctrlResize.mShowRight()
            mConstruitCarto()
        }
        else {
            ctrlResize.mHideRight()
            ctrlResize.mConstruitRight(function (contentElement) { contentElement.empty() })
            dxCarto.element().remove()
            dxCarto = null
        }
        dxGrid.option("noDataText", function (contentElement) {
            noDataText(contentElement)
        })
        Me.mGetToolbar().repaint()
    }

    function mConstruitCarto() {
        ctrlResize.mConstruitRight(function (contentElement) {
            var $DivCarto = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement)
            resizeObserver.mAdd($DivCarto, function () { Me.mGetToolbar().repaint() })
            dxCarto = $("<div style='width:100%;height:100%'/>").appendTo($DivCarto).dxCtrlCarto({
                bddCtrl: option.bddCtrl,
                context_grid: option.context_grid,
                onDisplayChanged: function (e) {
                    if (!dxCarto) return
                    dxGrid.mReloadData(dxCarto.mGetLstDataGridVisible())
                }
            }).dxCtrlCarto("instance")
        })
    }

    this.mGetLstFieldGrpSort = function () {
        //dxgrid == null si carto
        return (dxGrid ? dxGrid.mGetLstFieldGrpSort() : [])
    }

    this.mRefresh = function () {
        dxGrid.mRefresh()
    }

    this.component = function () { return dx; }
    this.element = function () { return container; }

    mConstruit();
}